<a href="#main-content" class="govuk-skip-link" data-module="govuk-skip-link" (click)="skipToMainContent($event)">Skip to main content</a>

<!-- The basket timer replaces the idle time-out while a slot is held. -->
@if (!basketTimer.showing) {
<ui-timeout></ui-timeout>
}
<app-header></app-header>

<!-- <app-skip-to-content></app-skip-to-content> -->

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-beat"
  [fullScreen]="true"
>
  <p style="color: white">Processing... Please Wait</p>
</ngx-spinner>
<main
  class="govuk-main-wrapper govuk-main-wrapper--l"
  role="main"
  tabindex="-1"
>
  <alert role="alert" aria-live="polite"></alert>
  <router-outlet></router-outlet>
  @if (basketTimer.showing) {
  <app-basket-timer></app-basket-timer>
  }
</main>


<app-footer></app-footer>
